
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.198.383l.068.138 4.852 12.507-1.256 1.27-1.093-2.817H3.265l-1.693 4.393a.813.813 0 01-.912.508l-.141-.041a.821.821 0 01-.504-.92l.04-.141L5.752.523a.812.812 0 011.447-.14zM6.51 3.075L3.9 9.841h5.235L6.51 3.075zM6.336 25.98l4.303-.956h.036a1.544 1.544 0 001.087-.449l11.783-11.683a1.54 1.54 0 000-2.184l-2.62-2.606a1.568 1.568 0 00-2.203 0l-11.79 11.69a1.494 1.494 0 00-.44 1.097l-.969 4.285a.67.67 0 00.3.718.698.698 0 00.516.09M19.405 8.78a.595.595 0 01.835 0l2.622 2.605a.572.572 0 01.13.638.587.587 0 01-.13.19l-1.136 1.127-3.46-3.431 1.139-1.13zM7.93 20.156l9.651-9.571 3.46 3.43-9.65 9.572-3.461-3.43zm-.935 2.9l.456-2.02 3.06 3.036-2.189.484-1.327-1.5z","fill":"#333"}})])
          )
        }
      }
    